export const reports = "/reports";
export const root = "/";
export const settings = "/settings";
